module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"ocean\"-in-inglewood-california-89b63d7b656960fd537406c7c293031d.png";